import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { GoldDots } from "@/components/Brand";
import { useApi } from "@/lib/api";
import { Panel, PrivacyNote, Stat } from "@/components/admin/AdminUI";

export const AdminOverview = ({ go }) => {
  const api = useApi();
  const nav = useNavigate();
  const [s, setS] = useState(null);
  useEffect(() => { api.get("/admin/summary").then((r) => setS(r.data)); }, [api]);
  if (!s) return <div className="py-16 flex justify-center"><GoldDots /></div>;
  return (
    <div className="space-y-5">
      <Panel title="People" testId="overview-people">
        <div className="grid gap-3 grid-cols-2 lg:grid-cols-4">
          <Stat n={s.people} label="People" testId="ov-people" />
          <Stat n={s.members} label="Members" testId="ov-members" />
          <Stat n={s.new_this_week} label="Joined this week" testId="ov-new" />
          <Stat n={s.signed_in_this_week} label="Signed in this week" testId="ov-signed-in" />
        </div>
      </Panel>
      <Panel title="Plans and care" testId="overview-plans">
        <div className="grid gap-3 grid-cols-2 lg:grid-cols-4">
          <Stat n={s.active_plans} label="Active plans" testId="ov-active" />
          <Stat n={s.completed_plans} label="Completed plans" testId="ov-completed" />
          <Stat n={s.open_alerts} label="Open safety alerts" testId="ov-alerts" />
          <Stat n={s.awaiting_consent} label="Yet to confirm terms" testId="ov-consent" />
        </div>
        <PrivacyNote />
      </Panel>
      <Panel title="At a glance" testId="overview-glance">
        <ul className="space-y-3 text-[15px]">
          <li className="flex items-center justify-between gap-4"><span>Action Plans are <strong>{s.plans_open ? "open to everyone" : "closed to the public"}</strong></span>
            <button className="btn-quiet text-sm" onClick={() => go("access")} data-testid="ov-go-access">Change</button></li>
          <li className="flex items-center justify-between gap-4"><span>{s.new_feedback} new feedback {s.new_feedback === 1 ? "message" : "messages"}</span>
            <button className="btn-quiet text-sm" onClick={() => go("feedback")} data-testid="ov-go-feedback">Feedback</button></li>
          <li className="flex items-center justify-between gap-4"><span>{s.migrated} people came across from go-native-2</span>
            <button className="btn-quiet text-sm" onClick={() => go("data")} data-testid="ov-go-data">Data</button></li>
          <li className="flex items-center justify-between gap-4"><span>{s.suspended} suspended accounts</span>
            <button className="btn-quiet text-sm" onClick={() => go("people")} data-testid="ov-go-people">People</button></li>
          <li className="flex items-center justify-between gap-4"><span>See the getting-started journey as a new visitor does</span>
            <button className="btn-quiet text-sm" onClick={() => nav("/start")} data-testid="replay-onboarding-btn">Replay onboarding</button></li>
        </ul>
      </Panel>
    </div>
  );
};
